import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/apiClient";
import { Plus, Calendar, ChevronRight, ClipboardList } from "lucide-react";

export default function VisitsList() {
  const [visits, setVisits] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      const { data } = await api.get("/visits");
      setVisits(data);
      setLoading(false);
    })();
  }, []);

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between gap-3">
        <h1 className="font-heading font-black text-2xl sm:text-3xl tracking-tight">Visites</h1>
        <Link
          to="/visites/nouvelle"
          data-testid="new-visit-btn"
          className="inline-flex items-center gap-2 bg-emerald-500 hover:bg-emerald-600 text-white font-bold px-4 py-2.5 rounded-full transition-all active:scale-95 shadow-lg shadow-emerald-500/30"
        >
          <Plus className="w-4 h-4" strokeWidth={3} /> Nouvelle
        </Link>
      </div>

      {loading ? (
        <div className="text-center text-stone-400 py-10">Chargement...</div>
      ) : visits.length === 0 ? (
        <div className="bg-white rounded-3xl border border-dashed border-stone-200 p-10 text-center">
          <ClipboardList className="w-10 h-10 text-stone-300 mx-auto mb-2" strokeWidth={2} />
          <div className="font-heading font-black text-lg">Aucune visite</div>
          <Link
            to="/visites/nouvelle"
            data-testid="empty-new-visit"
            className="inline-flex items-center gap-2 bg-emerald-500 hover:bg-emerald-600 text-white font-bold px-5 py-2.5 rounded-full mt-4"
          >
            <Plus className="w-4 h-4" strokeWidth={3} /> Première visite
          </Link>
        </div>
      ) : (
        <div className="space-y-3">
          {visits.map((v) => (
            <Link
              key={v.id}
              to={`/clients/${v.client_id}`}
              data-testid={`visit-row-${v.id}`}
              className="block bg-white rounded-3xl border border-stone-100 p-4 hover:-translate-y-0.5 hover:shadow-lg transition-all"
            >
              <div className="flex items-center gap-3">
                <div className="flex flex-col items-center justify-center bg-stone-50 rounded-2xl px-3 py-2 shrink-0 w-16">
                  <span className="text-[10px] uppercase tracking-wider font-bold text-stone-500">
                    {new Date(v.visit_date).toLocaleDateString("fr-FR", { month: "short" })}
                  </span>
                  <span className="font-heading font-black text-2xl leading-none">
                    {new Date(v.visit_date).getDate()}
                  </span>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="font-heading font-black text-base truncate">{v.client_name}</div>
                  {v.next_visit_date && (
                    <div className="mt-1 text-xs text-stone-500 inline-flex items-center gap-1 font-bold">
                      <Calendar className="w-3.5 h-3.5" strokeWidth={2.5} /> Relance :{" "}
                      {new Date(v.next_visit_date).toLocaleDateString("fr-FR")}
                    </div>
                  )}
                </div>
                <ChevronRight className="w-5 h-5 text-stone-400 shrink-0" strokeWidth={2.5} />
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
